import { render } from "./ProfileList.vue?vue&type=template&id=7acdc900"
import script from "./ProfileList.vue?vue&type=script&lang=js"
export * from "./ProfileList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__